import { render, staticRenderFns } from "./mc-clicker.vue?vue&type=template&id=5dc97261&scoped=true"
import script from "./mc-clicker.vue?vue&type=script&lang=ts"
export * from "./mc-clicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc97261",
  null
  
)

export default component.exports